export const TAB_PATHS = ['/', '/meus-arquivos', '/meus-exames'];

export default class HomeV2Model {
  static getActiveTabIndex(pathname: string): number {
    const index = TAB_PATHS.findIndex(path => path === pathname);
    return index === -1 ? 0 : index;
  }

  static isTabsVisible(fileCategoryMatch: unknown, examCategoryMatch: unknown): boolean {
    return !fileCategoryMatch && !examCategoryMatch;
  }
}
